import { render, staticRenderFns } from "./EmailSetupPreview.vue?vue&type=template&id=4a8b89e0&scoped=true&lang=pug&"
import script from "./EmailSetupPreview.vue?vue&type=script&lang=js&"
export * from "./EmailSetupPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8b89e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VIcon,VSkeletonLoader})
